import './SearchRestaurants.css';
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { isNil } from '../../utils/IsNil';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as SearchIcon } from "../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../resources/icons/close.svg";
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const SearchRestaurants = /*#__PURE__*/memo(_ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const history = useHistory();
  const [isVdsite, setIsVdsite] = useState(true);
  const [value, setValue] = useState("");
  const url = get(fields, 'data.datasource.searchPage.jss.value.href');
  const dictionary = get(fields, 'data.moduleDictionary');
  const placeholderText = getDictionaryItem(dictionary, 'PlaceholderText');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const analyticsButtonClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), text);
  };
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('SearchRestaurants component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SearchRestaurants component is empty: please provide data source]");
    }
    return null;
  }
  const goToUrl = () => {
    history.push(`${url}?title=${value}`);
    window.location.reload();

    // window.location.href = `${url}?title=${value}`;
  };
  const handleKeyPress = event => {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim()) {
      analyticsButtonClick(value);
      goToUrl();
    }
  };
  const handleGoClick = () => {
    analyticsButtonClick(value);
    goToUrl();
  };
  const handleCloseClick = () => {
    setValue('');
  };
  const handleTextInput = e => {
    setValue(e.target.value);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-search-text",
    placeholder: placeholderText,
    onKeyPress: handleKeyPress,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    "aria-label": placeholderText || 'Discover restaurants across Dubai',
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null)));
});
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cyzdz2n";
const ltrStyles = "l14cw4qd";
const rtlStyles = "r1l841tp";
export default SearchRestaurants;